import React from "react";
import { useTranslation } from "@lib/i18n";

import ErrorPage from "@components/shared/ErrorPage";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <ErrorPage
      title={t("seo.404.title")}
      description={t("seo.404.description")}
    />
  );
};

export default NotFound;
